import { Button } from "@components/Button/Button";
import { RenderImg } from "@components/RenderIcon/RenderImg";
import ThinkingImg from "@assets/images/Thinking.svg";
import { useTranslation } from "react-i18next";
import { Wrapper, InfoWrapper, IconWrapper, ButtonWrapper } from "./component";
import { TopicStyle, DescStyle } from "./style";
import { onPostMsgToGrab } from "./functional";
import liff from "@line/liff";
import { removeLS } from "@utils";
import { useAuthContext } from "@providers/AuthProvider";
import { LS_AUTH } from "@configs";

export const NoConsentPage: React.FC = () => {
  const { t } = useTranslation();
  const { authorizeState } = useAuthContext();

  return (
    <Wrapper>
      <IconWrapper>
        <RenderImg
          src={ThinkingImg}
          alt="thinking"
          width={"50%"}
          height={"auto"}
        />
      </IconWrapper>
      <InfoWrapper>
        <TopicStyle className="text-center">
          {t("status.no_consent.topic")}
        </TopicStyle>
        <DescStyle className="text-center">
          {t("status.no_consent.desc")}
        </DescStyle>
        <ButtonWrapper>
          <Button
            variant="success"
            onClick={() => {
              liff.closeWindow();
              onPostMsgToGrab({
                msg: `DATA:{"login_method": "${
                  authorizeState?.loginMethod ?? "APP"
                }"}`,
              });
              onPostMsgToGrab({
                msg: "ERROR:NO_CONSENT",
              });
              removeLS(LS_AUTH);
            }}>
            {t("button.close")}
          </Button>
        </ButtonWrapper>
      </InfoWrapper>
    </Wrapper>
  );
};
